import greiffModernRf from './GreiffModernRf.jpg';

export const greiffModernRfImpressions = {
    greiffModernRf,
};
